import React, {Component} from "react";
class Blocks extends Component {
    render() { 

        return (
            <div className="container py-5 px-3 text-justify text-black" dangerouslySetInnerHTML={{__html: this.props.content.content}}></div>
        )
    }
}

export default Blocks;